export const buildRoundBetId = (mainDataId: string | number, betIndex: number): string => {
    return `${mainDataId}_${betIndex}`;
};
